import Marquee3k from 'marquee3000/marquee3k.min.js'

const SELECTORS = Selectors({
  ticker: 'js-ticker'
})

const props = {
  $tickers: document.querySelectorAll(SELECTORS.asClass('ticker'))
}

const fn = {
  init: () => {
    Marquee3k.init({
      selector: SELECTORS.ticker
    })
  }
}

export default {
  can: () => props.$tickers.length,
  run: fn.init
}
